import ActionResult from 'app/src/engine/action-results/ActionResult';
import MoveMovableItemActionResult, {
	MoveMovableItemActionResultResult,
	MoveMovableItemActionResultType,
} from 'app/src/engine/action-results/MoveMovableItemActionResult';
import InstructionSegment, {
	InstructionSegmentStatus,
} from 'app/src/engine/instructions/InstructionSegment';
import MovableItem, { MovableItemOrientation } from 'app/src/engine/movable-items/MovableItem';
import GameStateStore from 'app/src/game/GameStateStore';

export enum RotateInstructionSegmentType {
	TurnLeft,
	TurnRight,
}

export default class RotateInstructionSegment extends InstructionSegment {
	private _type: RotateInstructionSegmentType;
	get type(): RotateInstructionSegmentType {
		return this._type;
	}

	constructor(type: RotateInstructionSegmentType) {
		super();

		this._type = type;
	}

	public getActionResults(
		gameStateStore: GameStateStore,
		movableItem: MovableItem,
	): { status: InstructionSegmentStatus; actionResults: ActionResult[] } {
		const movableItemLocation = gameStateStore.movableItemLocations.get(movableItem)!;
		const actionResult = new MoveMovableItemActionResult(movableItem, movableItemLocation);

		actionResult.movementType = MoveMovableItemActionResultType.Drive;
		actionResult.movementResult = MoveMovableItemActionResultResult.Move;
		actionResult.newLocation = movableItemLocation;

		if (this._type === RotateInstructionSegmentType.TurnLeft) {
			actionResult.newLocation.turns -= 1;

			switch (movableItemLocation.orientation) {
				case MovableItemOrientation.Up:
					actionResult.newLocation.orientation = MovableItemOrientation.Left;
					break;
				case MovableItemOrientation.Right:
					actionResult.newLocation.orientation = MovableItemOrientation.Up;
					break;
				case MovableItemOrientation.Down:
					actionResult.newLocation.orientation = MovableItemOrientation.Right;
					break;
				case MovableItemOrientation.Left:
					actionResult.newLocation.orientation = MovableItemOrientation.Down;
					break;
			}
		} else {
			actionResult.newLocation.turns += 1;

			switch (movableItemLocation.orientation) {
				case MovableItemOrientation.Up:
					actionResult.newLocation.orientation = MovableItemOrientation.Right;
					break;
				case MovableItemOrientation.Right:
					actionResult.newLocation.orientation = MovableItemOrientation.Down;
					break;
				case MovableItemOrientation.Down:
					actionResult.newLocation.orientation = MovableItemOrientation.Left;
					break;
				case MovableItemOrientation.Left:
					actionResult.newLocation.orientation = MovableItemOrientation.Up;
					break;
			}
		}

		// Ask the tile if it should be transformed.
		actionResult.askTileToTransform(gameStateStore);

		return { status: InstructionSegmentStatus.Success, actionResults: [actionResult] };
	}
}
